import {VirtualTableColumnCellsEnum} from '../../../../../../../../src/components/common/table/helpers/tableHelpers';
import {DynamicTableColumn} from '../../../../../../../../src/components/common/table/tableColumn';
import {CustomFieldsEnum} from '../../../../../../../../src/models/api/customFieldModel';
import {VisualSizesEnum} from '../../../../../../../shared/ui/src/styles/commonStyles';

export enum ColumnWidthsEnum {
  LARGE = 272,
  MEDIUM = 208,
  SMALL = 172,
}

export enum SharedColumnsEnum {
  DYNAMIC = 'dynamic',
}

export const dynamicColumns: ReadonlyArray<DynamicTableColumn<SharedColumnsEnum>> = [
  {
    type: SharedColumnsEnum.DYNAMIC,
    cellType: VirtualTableColumnCellsEnum.TEXT,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.MEDIUM,
      },
    },
  },
  {
    type: SharedColumnsEnum.DYNAMIC,
    cellType: VirtualTableColumnCellsEnum.INBOX,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.MEDIUM,
      },
    },
  },
  {
    type: SharedColumnsEnum.DYNAMIC,
    cellType: VirtualTableColumnCellsEnum.TEAMMATE,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.MEDIUM,
      },
      loading: {
        avatarSize: VisualSizesEnum.SMALL,
      },
    },
  },
  {
    type: SharedColumnsEnum.DYNAMIC,
    cellType: VirtualTableColumnCellsEnum.DATE,
    settings: {
      cellWidth: {
        width: ColumnWidthsEnum.MEDIUM,
      },
    },
  },
];

export function getDynamicColumnConfigFromCustomFieldType(customFieldType: CustomFieldsEnum) {
  switch (customFieldType) {
    case CustomFieldsEnum.INBOX:
      return dynamicColumns.find((col) => col.cellType === VirtualTableColumnCellsEnum.INBOX);
    case CustomFieldsEnum.TEAMMATE:
      return dynamicColumns.find((col) => col.cellType === VirtualTableColumnCellsEnum.TEAMMATE);
    case CustomFieldsEnum.DATETIME:
      return dynamicColumns.find((col) => col.cellType === VirtualTableColumnCellsEnum.DATE);
    case CustomFieldsEnum.BOOLEAN:
    case CustomFieldsEnum.STRING:
    default:
      return dynamicColumns.find((col) => col.cellType === VirtualTableColumnCellsEnum.TEXT);
  }
}
